export function isDateInTheFuture (date: Date): boolean {
  return date.getTime() > new Date().getTime()
}

export function formatDate (notFormattedDate: Date | string | number): string {
  const date = new Date(notFormattedDate)
  const d = date.getDate()
  const m = date.getMonth() + 1 // Month from 0 to 11
  const y = date.getFullYear()
  return (m <= 9 ? '0' + m : m) + '/' + (d <= 9 ? '0' + d : d) + '/' + y
}
